export const LOCATION_TYPE_CURRENT_LOCATION = "CURRENT_LOCATION"